// extracted by mini-css-extract-plugin
module.exports = {"container":"FavoritesAside_container__GZNEi","favoriteLink":"FavoritesAside_favoriteLink__6dCNY","favoriteIcon":"FavoritesAside_favoriteIcon___oEg7"};